export default __webpack_public_path__ + "static/media/Logo.15fd619d.png";